import { Component, OnInit } from "@angular/core";
import { faBriefcase, faSuitcase, faChartLine, faWallet, faHistory } from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import { UserTypes } from '@shared/enums';
import { User } from '@shared/models';

@Component({
  selector: "app-root",
  templateUrl: "./root.component.html",
  styleUrls: ["./root.component.css"]
})
export class RootComponent implements OnInit {
  faBriefcase = faBriefcase;
  faSuitcase = faSuitcase;
  faChartLine = faChartLine;
  faWallet = faWallet;
  faHistory = faHistory;
  UserTypes = UserTypes;
  userLogado: User;

  routerName: String = '';
  activityRootRouter: String = "";
  activitySecundaryRouter: String = "";

  constructor(private router: Router) {
    this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
  }

  ngOnInit() {
  }

  ngAfterViewInit() {}

  getRootRouter() {
    const split = this.router.url.split("/").filter(Boolean);

    if (split.length === 1) {
      this.routerName =  "Previsão de Venda";
      this.activityRootRouter = "previsao";
    } else {
      const rootRouter = split[1];

      if (rootRouter === "home" || rootRouter === "previsao-venda") {
        this.routerName = "Previsão de Venda";
        this.activityRootRouter = "previsao";

      } else if (rootRouter === "cliente-movimentacao") {
        this.routerName = "Clientes sem Movimentação";
        this.activityRootRouter = "movimentacao";
      } else if (rootRouter === "carteira-pedido") {
        this.routerName = "Carteira de Pedidos";
        this.activityRootRouter = "carteira";
      } else if (rootRouter === "debitos-aberto") {
        this.routerName = "Débitos em Aberto";
        this.activityRootRouter = "debito";
      } else if (rootRouter === "espelho-pedido") {
        this.routerName = "Cópia de pedidos";
        this.activityRootRouter = "espelho";
      } else if (rootRouter === "carteira-clientes") {
        this.routerName = "Carteira de Clientes";
        this.activityRootRouter = "carteiraClientes";
      } else if (rootRouter === "acompanhamento-previsao") {
        this.routerName = "Acompanhar Lançamentos p/ Cliente";
        this.activityRootRouter = "acompanhamento-previsao";
      } else if (rootRouter === "visao-cidade") {
        this.routerName = "Visão P/ Cidade";
        this.activityRootRouter = "visao-cidade";
      } else if (rootRouter === "acompanhar-lancamento-setor") {
        this.routerName = "Acompanhar Previsão p/ setor";
        this.activityRootRouter = "acompanhar-lancamento-setor";
      }else if (rootRouter === "historico-recepcao-transmissao") {
        this.routerName = "Histórico de Transmissão e Recepção";
        this.activityRootRouter = "historico-recepcao-transmissao";
      } else if (rootRouter === "liberar-digitacao-trc") {
        this.routerName = "Liberar Digitação TRC";
        this.activityRootRouter = "liberarDigitacaoTRC";
      }else if (rootRouter === "relatorio-vendas") {
        this.routerName = "Relatorio Vendas Por Cidade";
        this.activityRootRouter = "relatorio-vendas";
      }

      this.activitySecundaryRouter = "";

      if (split.length > 2) {
        this.getSecundaryRouter(split[2]);
      }
    }
  }

  getSecundaryRouter(router) {
    const routers = {
      "realizar-planejamento": "Realizar planejamento",
      "realizar-rateio": "Realizar rateio",
      "exibir-previsao": "Exibir previsão",
      "visao-cidade": "Visão p/ cidade",
      "acompanhamento-previsao":"Acompanhar Previsão Por Cliente",
      "acompanhar-lancamento-setor":"Acompanhar Previsão Por Setor"
    };

    this.activitySecundaryRouter = routers[router];
  }

  onActivate(event) {
    this.getRootRouter();
  }
}
